import { CALL_API_METHODS } from "repoV2/constants/apis";
import { isRequestSuccessful } from "repoV2/utils/common/api/api";
import { callApi } from "repoV2/utils/common/api/callApi";
import { OTP_PURPOSE, USER_DETAILS_APIS } from "./UserDetails.api.constants";

export const generateUserDetailsUpdateOTP = ({
    requestId: request_id,
}: {
    requestId: string;
}) =>
    callApi({
        url: USER_DETAILS_APIS.GENERATE_OTP_FOR_ACCOUNT_DETAILS_UPDATE,
        method: CALL_API_METHODS.POST,
        data: {
            request_id,
            otp_purpose: OTP_PURPOSE.details_verifications,
        },
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    })
        .then((apiResponse: any) => {
            const { status, message } = apiResponse?.data || {};
            if (!isRequestSuccessful(status)) throw new Error(message);
        })
        .catch((error: any) => {
            throw new Error(error?.response?.data?.message);
        });

export const verifyUserDetailsUpdateOTP = ({
    otp,
    requestId: request_id,
}: {
    otp: string;
    requestId: string;
}) =>
    callApi({
        url: USER_DETAILS_APIS.VERIFY_OTP_FOR_ACCOUNT_DETAILS_UPDATE,
        method: CALL_API_METHODS.POST,
        data: {
            otp,
            request_id,
            otp_purpose: OTP_PURPOSE.details_verifications,
        },
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    })
        .then((apiResponse: any) => {
            const { status, message } = apiResponse?.data || {};
            if (!isRequestSuccessful(status)) throw new Error(message);
        })
        .catch((error: any) => {
            throw new Error(error?.response?.data?.message);
        });
